module.exports = {"id":"194795","name":"Gonzalo Jara","rating":"75","photo":"./data/images/photos/3/194795.png","club":{"name":"Uni. de Chile","logo":"./data/images/clubs/Uni.deChile.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GonzaloJara0.json
// module id = 1625
// module chunks = 0